import React from 'react';
import './ActivationButton.css';
import { Language, t } from '../data/translations';

interface ActivationButtonProps {
    onClick: () => void;
    label: 'Accept' | 'Confirm';
    placement?: 'above' | 'below';
    language: Language;
}

const ActivationButton: React.FC<ActivationButtonProps> = ({ onClick, label, placement = 'above', language }) => {
    const positionClass = placement === 'below'
        ? 'top-full mt-2 left-1/2 -translate-x-1/2'
        : '-top-12 left-1/2 -translate-x-1/2';

    return (
        <button
            id={label === 'Accept' ? 'btn-accept' : undefined}
            onClick={onClick}
            className={`activation-button-container absolute ${positionClass} transition-all duration-300 shadow-lg z-[9999]`}
        >
            <div
                className="border-gradient-bottom"
                style={{
                    background: 'radial-gradient(circle, #ff6b35, transparent 10%)',
                    animationDuration: '4s'
                }}
            ></div>
            <div
                className="border-gradient-top"
                style={{
                    background: 'radial-gradient(circle, #ffa559, transparent 10%)',
                    animationDuration: '4s'
                }}
            ></div>
            <div className="activation-button-inner">
                {label === 'Accept' ? t('ui.accept', language) : t('ui.confirm', language)}
            </div>
        </button>
    );
};

export default ActivationButton;
